<template>
  <b-overlay class="processContainer" id="processContainer-background" :show="loading" rounded="sm">
    <div class="dashProcess">
      <div>
        <div v-if="this.user && this.user.Permissions.editarplanejamentoproducao.allowed">
          <div id="toolbar" v-if="!readOnly">
            <div>
              <b-button class="btnSave" variant="secondary" @click="saveCurrentFlowchart">
                <b-icon icon="cloud-upload" aria-hidden="true" class="mr-1" :title="$t('saveFlowSheet')"></b-icon>
                {{ $t('saveFlowSheet') }}
              </b-button>
            </div>

            <div>
              <b-button class="btnSave" variant="secondary" @click="showAreas">
                <b-icon class="mr-1" icon="Upload" aria-hidden="true" :title="$t('importExport')"></b-icon>
                {{ $t('importExport') }}
              </b-button>
            </div>

            <div>
              <b-button class="btnSave" variant="secondary" @click="resetOperations"
                title="Utilize sempre que atualizar o XML e houver mudança na quantidade de equipamentos.">
                <b-icon class="mr-1" icon="arrow-clockwise" aria-hidden="true" :title="$t('resetOperations')"></b-icon>
                {{ $t('resetOperations') }}
              </b-button>
            </div>

            <NodesButtons :factoryCtrl="factoryCtrl" :openDialog="openDialog" :loadFlowchartTo="loadFlowchartTo"
              :selectionArea="selectionArea" :typesNodes="typesNodes" id="nodesPCP" />
          </div>
        </div>
      </div>
      <div>
        <div id="canvas" @dragover="allowDrop" @drop="createNode" @mousedown="selectionArea.start($event)"
          @mousemove="selectionArea.move($event)" />

        <Dialog :dialogVisible="showDialog" :node="nodeRefToDialog" />

        <DialogReadOnly :dialogVisibleShow="showDialogReadOnly" :node="nodeRefToDialog" :types="typesNodes" />

        <b-button-group class="buttons-bottom">
          <b-button title="Visualização padrão" @click="setResizeSVG">
            <b-icon icon="arrows-fullscreen"></b-icon>
          </b-button>
        </b-button-group>

        <span class="descriptionArea">
          {{ captionArea }}
        </span>
      </div>
    </div>
    <b-modal id="confirmSave" ok-variant="danger" :ok-title="$t('yes')" :cancel-title="$t('no')" @ok="confirmSaveArea"
      @cancel="cancelSaveArea" title="Confirmar Modificações" :no-close-on-backdrop="true">
      Deseja salvar as alterações realizadas no diagrama?
    </b-modal>
    <b-modal id="importExport" :title="$t('importExportModalTitle')" hide-footer>
      <ImportExport :areas="areasFlowchart"></ImportExport>
    </b-modal>

    <b-modal id="canReloadXml" title="Recarregar o PAP" ok-variant="danger" :ok-title="$t('yes')" @ok="reloadXml"
      @cancel="setReadOnly">
      {{ $t('deseja-recarregar-as-configuracoes-do-xml-isso-pode-demorar-um-pouco') }}
    </b-modal>

  </b-overlay>
</template>

<script>
import * as d3 from "d3";
import BuildSVG from "./utils/buildSVG";
import axios from "axios";
import Dialog from "./Dialog.vue";
import DialogReadOnly from "./DialogReadOnly";
import ImportExport from "../importExport/importExport.vue"
import { urlMainAPI, defaultSuccess } from "@/global";
import { SingletonEnginnering } from "./nodes/_service/singletonEngineering";
import { SingletonFlowchart } from "./nodes/_service/singletonFlowchart";
import { SingletonAreas } from "./nodes/_service/singletonAreas";
import RebuilderNodes from "./nodes/_service/singletonTools/RebuilderNodes";
import { GetNewController } from "./nodes/_service/factoryController";
import { cleanUndoRedo } from "./nodes/_service/undoRedo";
import { Selection } from "./nodes/_service/selectionService";
import { ShortCuts } from "./utils/ShortCuts";
import { mapState } from "vuex";
import { Types } from "./utils/nodeTypes";
import imagesOfTheAreas from "./utils/imagesOfTheAreas";
import { GetSVGCoordinates } from "./utils/tools";
import { SingletonInter } from "./nodes/_service/singletonInter";
import NodesButtons from "./nodesButtons/NodesButtons.vue";

export default {
  name: "PCP",
  components: { Dialog, DialogReadOnly, NodesButtons, ImportExport },

  inject: ["showLoading"],

  props: [
    "sendNodes",
    'reloadNodes',
    'resetNodes',
    'backFlowChart',
    "flagEditMode",
    "changeViewFlow",
    'flowchartTo',
  ],

  computed: mapState(["user"]),

  data() {
    return {
      unitId: parseInt(this.$store.state.user.UnitId),
      typesNodes: new Types(),
      selectionArea: new Selection(),
      loading: false,
      showDialog: 0,
      showDialogReadOnly: 0,
      nodeRefToDialog: null,
      factoryCtrl: GetNewController,
      areas: imagesOfTheAreas,
      readOnly: true,
      captionArea: "",
      pathAreas: [],
      areasFlowchart: [],
      loaded: false,
      canReloadXml: false,
    };
  },

  watch: {
    flagEditMode(value) {
      SingletonAreas.SaveStatus();
      if (value) {
        this.readOnly = !value;
        this.setEditMode()
      }
      else
        this.$bvModal.show("canReloadXml")
    },

    captionArea(value) {
      SingletonAreas.currentArea = value;
    },

    async sendNodes() {
      let listInputProperties = await SingletonAreas.getAllPropertiesToSimulation();
      let tableFlowChart = SingletonEnginnering.setTableFlowChart(listInputProperties);

      this.$emit("sendInputList", tableFlowChart);
    },

    async reloadNodes(objectStructure) {
      await SingletonAreas.LoadScenario(objectStructure)
      this.loading = false;

      this.showLoading(false);
    },

    async resetNodes() {
      SingletonFlowchart.Memory.resetPropertyValues();
      SingletonFlowchart.Memory.reloadNodes();
    },

    backFlowChart() {
      if (SingletonFlowchart.wasModified) {
        this.$bvModal.show("confirmSave");
      } else {
        this.updateCurrentArea();
        setTimeout(async () => {
          await this.loadDatabaseNodes(SingletonAreas.currentArea);
        }, 100)
      }
    },

    changeViewFlow(value) {
      SingletonFlowchart.changeView(value);
    },

    flowchartTo(call) {
      this.loadFlowchartTo(call.area)
    },
  },

  methods: {
    reloadXml() {
      this.$bvModal.hide("canReloadXml");
      this.canReloadXml = true;
      this.loading = true;
      setTimeout(() => {
        this.setReadOnly();
      }, 250);
    },

    allowDrop(event) {
      event.preventDefault()
    },

    resetOperations() {
      RebuilderNodes.rebuild(this.areasFlowchart, SingletonAreas.currentArea);
    },

    openDialog(node) {
      this.nodeRefToDialog = node;

      if (!this.readOnly) {
        SingletonFlowchart.unSelectNode();
        this.showDialog++;
        return;
      }

      if (this.typesNodes.inputNodes.includes(node.type))
        this.showDialogReadOnly++;
    },

    createNode(event) {
      let type = event.dataTransfer.getData("createNode");
      if (!type) return;
      let [x, y] = [...GetSVGCoordinates(event)];
      let ctr = this.factoryCtrl(parseInt(type));
      ctr && ctr.setNewNode(this.openDialog, { x, y });
    },

    removeNode() {
      let selection = SingletonFlowchart.selected;
      let selected = SingletonFlowchart.selectedNodes;
      if (selection || selected) {
        d3.selectAll(`.SelectionNode`).remove();
        SingletonFlowchart.removeNodeSelected();
      }
    },

    unSelected() {
      SingletonFlowchart.unSelectNode();
      this.selectionArea.cancelSelection();
    },

    updateCurrentArea() {
      this.pathAreas.pop();
      let index = this.pathAreas.length == 0 ? 0 : this.pathAreas.length - 1;
      this.captionArea = this.pathAreas[index];
    },

    async loadFlowchartTo(area) {
      SingletonAreas.areaOpenByNode = area;
      if (SingletonFlowchart.wasModified) {
        this.$bvModal.show("confirmSave");
      } else {
        SingletonAreas.SaveStatus();
        await this.loadDatabaseNodes(area);
        cleanUndoRedo(this);
        SingletonFlowchart.SaveStatus();
        SingletonFlowchart.wasModified = false;
      }
    },

    confirmSaveArea() {
      this.$bvModal.hide("confirmSave");
      this.saveCurrentFlowchart();
      if (!SingletonAreas.areaOpenByNode) {
        this.updateCurrentArea();
        this.loadDatabaseNodes(this.captionArea);
      } else {
        this.loadDatabaseNodes(SingletonAreas.areaOpenByNode);
      }
    },

    cancelSaveArea() {
      this.$bvModal.hide("confirmSave");
      if (!SingletonAreas.areaOpenByNode) {
        this.updateCurrentArea();
        this.loadDatabaseNodes(this.captionArea);
      } else {
        this.loadDatabaseNodes(SingletonAreas.areaOpenByNode);
      }
    },

    async showAreas() {
      this.$bvModal.show("importExport");
      this.areasFlowchart = await this.loadAreas();
    },

    async loadAreas() {
      let areas = sessionStorage.areasFlowchart;
      if (!areas) {
        const url = `${urlMainAPI}/getflowcharts/PCP`;
        await axios
          .get(url)
          .then((res) => {
            areas = res.data;
          })
          .catch();

          sessionStorage.areasFlowchart = JSON.stringify(areas);
        return areas;
      }
      areas = JSON.parse(areas);

      return areas;
    },

    async saveCurrentFlowchart() {
      let nodes = SingletonFlowchart.Memory.getNodesToSave();
      let width = document.querySelector("#canvas").clientWidth;
      let transform = document
        .querySelector("#board")
        .getAttribute("transform");

      let flowchart = {
        id: 0,
        area: SingletonAreas.currentArea,
        configuration: JSON.stringify(nodes),
        transform: transform + ` width(${width})`,
        type: "PCP",
      };

      if (this.saveFlowchart(flowchart)) {
        SingletonFlowchart.wasModified = false;
        defaultSuccess(this.$t("diagrama-salvo-com-sucesso"));
      }
    },

    async saveFlowchart(flowchart) {
      let success = false;
      const url = `${urlMainAPI}/saveflowchart/PCP`;

      await axios
        .post(url, flowchart)
        .then((res) => {
          if (res.status == 200) flowchart.id = res.data.id;
          success = true;
          SingletonAreas.UpdateArea(flowchart);
        })
        .catch(e => console.log(e));

      return success;
    },

    async loadDatabaseNodes(area = "PAP") {
      area = this.$t(area);

      let obj = {};
      obj.id = this.unitId;

      if (!SingletonEnginnering.isLoaded) {
        setTimeout(() => this.loadDatabaseNodes("PAP"), 1000);
        return;
      }

      if (!SingletonAreas.LoadedAreas()) {
        let areas = await this.loadAreas();

        await SingletonAreas.LoadAreas(areas);
        this.areasFlowchart = areas;
      }

      this.pathAreas = area == "PAP" ? new Array() : this.pathAreas;
      let areaNodes = SingletonAreas.GetArea(area);

      if (!areaNodes) {
        await axios
          .get(`${urlMainAPI}/loadflowchartbyarea/${area}/PCP`)
          .then(async (res) => {
            if (res.data)
              areaNodes = {
                configuration: JSON.parse(res.data.configuration),
                transform: res.data.transform,
              };
          });
      }

      SingletonFlowchart.Memory.clear();
      await SingletonFlowchart.loadArea(
        areaNodes,
        this.openDialog,
        this.loadFlowchartTo
      );
      this.loaded = false;
      SingletonFlowchart.wasModified = false;

      if (SingletonAreas.currentArea != area) {
        this.pathAreas.push(area);
      }

      this.captionArea = area;
      SingletonAreas.areaOpenByNode = "";

      this.loading = false;
      defaultSuccess(
        this.$t("area-0") + " " + `${area} ` + this.$t("carregada")
      );
    },

    configSVG() {
      let svg = BuildSVG.CreateSvg(this, true);
      SingletonFlowchart.svg = svg;
      cleanUndoRedo(this);
    },

    showToobar() {
      let dashProcess = document.querySelector(".dashProcess");
      let toolbar = document.querySelector("#toolbar");

      if (!dashProcess) return;

      if (!this.readOnly) {
        dashProcess.style["grid-template-columns"] = "150px 1fr";
        if (toolbar) {
          this.$nextTick(() => {
            document.querySelector("#toolbar").style.display = "block";
          });
          SingletonFlowchart.setReadOnly(false);
        }
      } else {
        dashProcess.style["grid-template-columns"] = "100%";
        SingletonFlowchart.setReadOnly();
      }
    },

    async setReadOnly() {
      this.readOnly = true;
      this.loading = true;

      SingletonFlowchart.readOnly = this.readOnly;
      SingletonFlowchart.Memory.clear();
      document.querySelector("#canvas").innerHTML = "";
      this.showToobar();
      this.configSVG();
      ShortCuts.Kill();
      await this.loadDatabaseNodes("PAP");

      // defaultSuccess(this.$t("restaurando-valores"));
      if (this.canReloadXml) {
        this.loading = true;
        setTimeout(async () => {
          await SingletonAreas.Reload();
          this.loading = false;
          this.canReloadXml = false;
        }, 300);
      }
    },

    async setEditMode() {
      SingletonFlowchart.readOnly = this.readOnly;
      SingletonFlowchart.Memory.clear();
      document.querySelector("#canvas").innerHTML = "";
      this.configSVG();
      await this.loadDatabaseNodes("PAP");
      this.showToobar();
      ShortCuts.Init(this);
    },

    checkReadyOnly() {
      this.readOnly = !this.user.Permissions.editarplanejamentoproducao.allowed;
      SingletonFlowchart.readOnly = this.readOnly;
    },

    checkModified() {
      if (SingletonFlowchart.wasModified) {
        this.$store.commit("setFlowchartStructure", {
          area: SingletonAreas.currentArea,
          configuration: JSON.stringify(
            SingletonFlowchart.Memory.getNodesToSave()
          ),
          type: "PCP",
        });
        this.$bvModal.show("confirmSaveFlowchart");
      }
    },

    setResizeSVG() {
      BuildSVG.SetTrasnform(1, 1, 1);
    },
  },

  async mounted() {
    this.loading = true;
    if (!this.readOnly) {
      await this.showToobar();
    }
    else {
      await this.setReadOnly();
    }
    await SingletonAreas.Reload();

    this.loading = false;

    SingletonFlowchart.openDialog = this.openDialog;
    SingletonFlowchart.loadDatabaseNodes = this.loadDatabaseNodes;
    SingletonFlowchart.axios = axios;
    SingletonInter.$t = this.$t;
  },

  beforeDestroy() {
    sessionStorage.removeItem("areasFlowchart");
    SingletonAreas.Kill();
    this.checkModified();
    ShortCuts.Kill();
  },
};
</script>

<style src="./index.css"></style>

<style>
#svg.pcp {
  background-color: #fff;
  border-radius: 5px;
  width: 100%;
  height: 61vh;
  border: 1px solid #0008;
  box-shadow: 0px 0px 3px #0008;
}

#nodesPCP.group-buttons {
  height: 57.5vh;
  overflow-y: auto;
}

.selected {
  border: 2px solid #222;
}

.dashProcess {
  display: grid;
  grid-template-columns: 100%;
  align-content: stretch;
  width: 100%;
  height: 100%;
}

#toolbar {
  display: none;
  grid-column-start: 1;
}

#canvas {
  grid-column-start: 2;
  cursor: crosshair;
}

.descriptionArea {
  float: right;
  font-weight: bold;
  font-size: 1.05em;
  color: rgba(0, 0, 0, 0.5);
}

.processContainer {
  padding: 0;
  margin: 0;
  padding: 0 5px 0px 0px;
}

.tableTxt {
  font-size: 0.8em;
}

.tableTxt:hover {
  cursor: pointer;
}

.rowDistance {
  margin-top: 20px;
}

.loadContainer {
  max-width: 600px;
}

#inputImport {
  display: none;
  text-overflow: ellipsis;
}

.buttons-bottom>button {
  border: 0.3px solid #0006;
  background: #0000;
  font-size: 8px;
  padding: 3px;
  color: #0006;
}

.title-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 130px;
}

.title-section>span {
  font-size: 0.7rem;
  margin: 0 0 9px 0;
  width: 100%;
  height: 13px;
  padding: 0 8px;
  text-align: center;
  border-bottom: 1px solid #0004;
}

.title-section>span>label {
  background-color: white;
  margin: 0;
  box-shadow: 0 2px 0 3px #fff8;
  padding: 0 3px;
  position: relative;
  top: 2px;
  transition-duration: 300ms;
}

.title-section>span>label:hover {
  font-weight: 700;
}

.color-buttons-utils {
  background-color: #00a39f !important;
  border: 1px solid #0006;
}

.color-buttons-operations {
  background-color: #222 !important;
  border: 1px solid #0006;
}

.color-buttons-areas {
  background-color: #ff5f00 !important;
  border: 1px solid #0006;
}

.color-buttons-utils:hover {
  background-color: #00a39f95 !important;
}

.color-buttons-operations:hover {
  background-color: #2229 !important;
}

.color-buttons-areas:hover {
  background-color: #ff5f0095 !important;
}

.buttons-bottom>button:focus {
  box-shadow: none;
  color: #0006;
  background: #0000;
}

@media (min-height: 760px) {
  #svg.pcp {
    height: 67vh;
  }

  #nodesPCP.group-buttons {
    height: 65vh;
  }
}

@media (max-width: 1310px) {
  #nodesPCP.group-buttons {
    height: 60vh;
  }
}

@media (max-height: 720px) {
  #nodesPCP.group-buttons {
    height: 50vh;
  }
}

@media (max-height: 720px) {
  #svg.pcp {
    height: 57vh;
  }

  #nodesPCP.group-buttons {
    height: 49vh !important;
  }
}

@media (min-height: 900px) {
  .pcp {
    height: 676px !important;
  }
}

@media (min-width: 1800px) {
  .pcp {
    height: 71vh !important;
  }
}

@media (max-width: 1160px) {
  #svg.pcp {
    height: 69vh;
  }

  #nodesPCP.group-buttons {
    height: 65vh;
  }
}

@media (min-height: 1050px) {
  #svg.pcp {
    height: 845px;
  }
}

@media (min-height: 1600px) {
  #svg.pcp {
    height: 1395px;
  }
}

@media only screen and (max-width: 1160px) {
  .content {
    top: 130px;
  }
}
</style>
